import React, { useEffect } from "react";
import { useState } from "react";

// Internal Imports
import EditTextForm from "../../../common/components/EditTextForm/EditTextForm";
import LoadingButton from "../../../common/components/LoadingButton/LoadingButton";
import MarginInput from "../../../common/components/MarginInput/MarginInput";
import Paint from "../../../common/components/Paint/Paint";
import { COLORS } from "../../../common/constants/colors";
import { useAuth } from "../../../contexts/auth";
import { useForm } from "../../../contexts/form";
import { IUserInformation } from "../../../interfaces/IUser";
import { getUserByUserName } from "../../../services/user";

interface Props {
    setCanGoNext: React.Dispatch<React.SetStateAction<boolean>>;
    goToUpdate: (user: IUserInformation) => void
}

const StepOne = ({ setCanGoNext, goToUpdate }: Props) => {

    // States
    const { setUserNameCreation } = useForm();
    const { userInformation } = useAuth();
    const [userName, setUserName] = useState<string>("");
    const [methodLoading, setMethodLoading] = useState<boolean>(false);
    const [canEdit, setCanEdit] = useState<boolean>(false);
    const [userFound, setUserFound] = useState<IUserInformation>();
    const [error, setError] = useState<string>("");

    const [errorColor, setErrorColor] = useState<string>(COLORS.blue_active);



    // Handles
    const handleVerifyUserExistence = () => {
        setCanEdit(false);
        setCanGoNext(false);
        setUserFound(undefined);
        setMethodLoading(true);

        getUserByUserName(userName.trim().toLowerCase())
            .then((response) => {
                setCanEdit(true);
                setUserFound(response.data);
                setErrorColor(COLORS.blue_active);

                if ((response.data as IUserInformation).usuarioProyecto === null) {
                    setError("Existe un usuario registrado con este Nombre de Usuario, puede hacer CLICK en EDITAR para AGREGARLO a este PROYECTO.");
                } else {

                    if (!!userInformation?.usuarioProyecto!.esAdministrador || userInformation?.usuarioProyecto!.departamentoGUID === (response.data as IUserInformation).usuarioProyecto?.departamentoGUID) {
                        setError("Existe un usuario registrado con este Nombre de Usuario, puede hacer CLICK en EDITAR para MODIFICARLO");
                    } else {
                        setCanEdit(false);
                        setError(`Existe un usuario registrado con este Nombre de Usuario, pero NO PUEDE MODIFICARLO porque pertenece al departamento ${(response.data as IUserInformation).usuarioProyecto?.departamentoNombre?.toUpperCase()}.`);
                        setErrorColor(COLORS.red_error2);
                    }
                }

            })
            .catch(() => {
                setCanGoNext(true);
                setUserNameCreation(userName);
                setError("No existe usuario registrado con este Nombre de Usuario, puede hacer CLICK en SIGUIENTE para CREARLO.");
            })
            .finally(() => {
                setMethodLoading(false);
            })
    }

    // Effects
    useEffect(() => {
        setCanEdit(false);
        setError("");
        setCanGoNext(false);
        setUserFound(undefined);
    }, [userName])

    return (
        <div style={{ marginTop: 50, display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}>
            <MarginInput width="45%">
                <label style={{ textAlign: 'center', fontSize: '1.6em' }}>Nombre de Usuario:</label>
                <EditTextForm
                    value={userName}
                    inForm={false}
                    onChange={setUserName}
                    backgroundcolor={COLORS.white_color2(1)}
                    name={"userName"}
                    placeholder={"Nombre del Usuario"}
                    borderColor={COLORS.black_text_color3}
                    textColor={COLORS.black_text_color1}
                    active={!methodLoading}
                    type={'text'}
                />
                <p style={{ fontSize: "0.9em", letterSpacing: 0.5, fontWeight: 300, padding: 5 }}>
                    {!!!userName
                        ? <Paint color={COLORS.red_error2}>{'Requerido'}</Paint>
                        : userName.trim().split(" ").length > 1
                            ? <Paint color={COLORS.red_error2}>{'No puede tener espacios en blanco'}</Paint>
                            : <Paint color={errorColor}>{error}</Paint>
                    }
                </p>
            </MarginInput>

            <div style={{ display: 'flex' }}>
                <LoadingButton
                    type="button"
                    disabled={methodLoading || !!!userName || userName.trim().split(" ").length > 1}
                    method={() => handleVerifyUserExistence()}
                    title={"Verificar"}
                    loading={methodLoading.toString()}
                    background={COLORS.blue_inactive(1)}
                    color={COLORS.blue_main(1)}
                    style={{ padding: '3px', width: '150px', height: '32px', marginRight: '5px' }}
                    fontsize={16}
                />
                <LoadingButton
                    type="button"
                    disabled={!canEdit}
                    method={() => goToUpdate(userFound!)}
                    title={"Editar"}
                    loading={'false'}
                    background={COLORS.blue_main(1)}
                    color={COLORS.white_color1}
                    style={{ padding: '3px', width: '150px', height: '32px', marginLeft: '5px' }}
                    fontsize={16}
                />
            </div>
        </div>
    );
}

export default StepOne;